<template>
  <panel label="账户信息">
    <el-row>
      <el-col :span="12">
        <div class="zhanghu-mesg of" v-for="(item, idx) in customerDetail.etcs" :key="idx">
          <div class="zhanghu-title">ETC账户</div>
          <ul>
            <li><a>账户名：</a><span>{{item.etc__ETCAccountName}}</span></li>
            <li><a>卡号：</a><span>{{item.etc__ETCAccountNo}}</span></li>
            <li><a>开卡日期：</a><span>{{item.etc__ETCSignupDate}}</span></li>
            <li><a>账户状态：</a><span>{{item.etc__ETCAccountStatus}}</span></li>
            <li><a>账户余额：</a><span>{{item.etc__ETCAccountBalance}}</span></li>
            <li><a>累积消费金额：</a><span>{{item.etc__ETCExpense}}</span></li>
          </ul>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="zhanghu-mesg of" v-for="(item, idx) in customerDetail.sinopecs" :key="idx" >
          <div class="zhanghu-title">中石化油卡</div>
          <ul >
            <li><a>账户名：</a><span>{{item.sinopec__sinopecAccountName}}</span></li>
            <li><a>卡号：</a><span>{{item.sinopec__sinopecAccountNo}}</span></li>
            <li><a>开卡日期：</a><span>{{item.sinopec__sinopecSignupDate}}</span></li>
            <li><a>账户状态：</a><span>{{item.sinopec__sinopecAccountStatus}}</span></li>
            <li><a>账户余额：</a><span>{{item.sinopec__sinopecAccountBalance}}</span></li>
            <li><a>累积消费金额：</a><span>{{item.sinopec__sinopecExpense}}</span></li>
          </ul>
        </div>
      </el-col>
    </el-row>
  </panel>
</template>

<script>
  export default {
    name: "CustomerDetailAccountComponent",
    data() {
      return {}
    },
    props:{
      value: {
        type: Object
      }
    },
    computed: {
      customerDetail: {
        get: function () {
          return this.value
        },
        set: function (newVal) {
          this.$emit('input', newVal)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/CustomerDetailAccountComponent.vue